export default "__VITE_ASSET__BqkcUdOF__"